import { useEffect, useState } from 'react';
import { ApolloError } from '@apollo/client/errors';
import {
  GET_ALL_ORGANISATIONS,
  Organisation,
} from '../../../../apollo/queries';
import {
  getApolloClient,
  ORGANISATION_SERVICE_ENDPOINT,
} from '../../../../apollo/getApolloClient';

interface AllOrganisationResponse {
  isLoading?: boolean;
  error?: ApolloError | null;
  organisations: Pick<Organisation, 'name' | 'code' | 'tenantCode'>[];
}

const useAllOrganisationsAPI = (
  isOrgMember: boolean = false,
): AllOrganisationResponse => {
  const client = getApolloClient(ORGANISATION_SERVICE_ENDPOINT);

  const [organisations, setOrganisations] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getOrganisations = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const { data } = await client.query({
        query: GET_ALL_ORGANISATIONS,
      });

      setOrganisations(data.organisations);
    } catch (e: any) {
      setError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    !isOrgMember && getOrganisations();
  }, []);

  return { organisations, isLoading, error };
};

export default useAllOrganisationsAPI;
